import { createSlice } from "@reduxjs/toolkit";
import { IAboutState } from "./aboutModel";
import {
  AboutDetailsImageUpload,
  getAboutDetails,
} from "./services/about.services";

const initialState: IAboutState = {
  loading: false,
  error: "",
  AboutDetails: {
    MottoCMS: "",
    VisionDescription: "",
    GoalDescription: "",
    MissionDescription: "",
    VisionAltText: "",
    GoalAltText: "",
    MissionAltText: "",
    VisionIcon:"",
    VisionImage:"",
    GoalIcon:"",
    GoalImage:"",
    MissionIcon:"",
    MissionImage:"",
  },
};

const aboutSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    clearAboutDetails: (state) => {
      state.AboutDetails = initialState.AboutDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAboutDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAboutDetails.fulfilled, (state, action: any) => {
      state.loading = false;
      state.AboutDetails = action.payload;
    });
    builder.addCase(getAboutDetails.rejected, (state, action) => {
      state.loading = false;
      state.AboutDetails = initialState.AboutDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(AboutDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(AboutDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(AboutDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearAboutDetails } = aboutSlice.actions;
export default aboutSlice.reducer;
